module.exports = __webpack_public_path__ + "static/media/asset8.2f7be9cc.svg";